module.exports = __webpack_public_path__ + "img/button_close_x.4f6b2bdf.svg";